export default "__VITE_ASSET__D083G8nP__"